module.exports = __webpack_public_path__ + "static/media/fee-profile.dfc5b19a.svg";